<div>
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">My Complaints</mat-card-title>
        <mat-card-content>
            <div>
                <mat-form-field appearance="outline" style="width: 450px;">
                    <mat-label>Search your complaints...</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Complaint No, Detail, Status etc...">
                </mat-form-field>
            </div>
            <div>
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Complaint ID Column -->
                    <ng-container matColumnDef="complaintId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint No</th>
                        <td mat-cell *matCellDef="let element">{{ element.complaintId }}</td>
                    </ng-container>
            
                    <!-- Complaint Description Column -->
                    <ng-container matColumnDef="complaintDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Details</th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintDescription }} </td>
                    </ng-container>
            
                    <!-- Complaint Date Column -->
                    <ng-container matColumnDef="complaintDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date & Time</th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintDate | date: 'medium' }} </td>
                    </ng-container>
            
                    <!-- Complaint Status Column -->
                    <ng-container matColumnDef="complaintStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let element">{{ getComplaintLineStatusTypeValue(element.complaintStatus) }}</td>
                    </ng-container>
            
                    <!-- Department Name Column -->
                    <ng-container matColumnDef="departmentName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Department</th>
                        <td mat-cell *matCellDef="let element"> {{ element.departmentName }} </td>
                    </ng-container>

                    <!-- Employee Number Column -->
                    <ng-container matColumnDef="employeeName">
                        <th mat-header-cell *matHeaderCellDef>Employee Name</th>
                        <td mat-cell *matCellDef="let element"> {{ element.employeeName }} </td>
                    </ng-container>

                    <!-- Department Name Column -->
                    <ng-container matColumnDef="employeeMobileNumber">
                        <th mat-header-cell *matHeaderCellDef>Employee Mobile No</th>
                        <td mat-cell *matCellDef="let element"> {{ element.employeeMobileNumber }} </td>
                    </ng-container>

                    <!-- Close Complaint Column -->
                    <ng-container matColumnDef="closeComplaint">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let element"> 
                            <button mat-button (click)="openDialog(element)">{{ element.complaintStatus === 'CLOSED' ? 'Re-Open' : 'Close' }}</button>
                        </td>
                    </ng-container>
            
                    <!-- Table Header and Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
                </table>
            
                <!-- Paginator -->
                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>